/* ------------------------------------------------------------------------------
 *
 *  # Mensajería Components
 *
 *  Funciones auxiliares para la funcionalidad de mensajería
 *
 * ---------------------------------------------------------------------------- */

// Scroll automático al final del chat
export function scrollToBottom(elementId) {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollTop = element.scrollHeight;
	}
}

// Inicializar contador de mensajes no leídos en el sidebar
export function updateUnreadCount(count) {
	const badge = document.querySelector('.nav-link[href="/protected/mensajeria"] .badge');
	if (badge) {
		badge.textContent = count;
		badge.style.display = count > 0 ? '' : 'none';
	}
}

// Preview de imagen antes de enviar
export function previewImage(inputElement, previewElement) {
	if (!inputElement || !inputElement.files || !inputElement.files[0]) {
		return;
	}

	const file = inputElement.files[0];
	
	// Validar que sea una imagen
	if (!file.type.startsWith('image/')) {
		window.showNotification('Solo se permiten imágenes', 'error');
		return false;
	}

	// Validar tamaño (máximo 5MB)
	if (file.size > 5 * 1024 * 1024) {
		window.showNotification('La imagen no debe superar 5MB', 'error');
		return false;
	}

	const reader = new FileReader();
	reader.onload = function(e) {
		if (previewElement) {
			previewElement.src = e.target.result;
			previewElement.style.display = 'block';
		}
	};
	reader.readAsDataURL(file);
	
	return true;
}

// Upload de imagen
export async function uploadImage(file, dotNetRef) {
	const formData = new FormData();
	formData.append('file', file);

	try {
		const response = await fetch('/api/upload/image', {
			method: 'POST',
			body: formData,
			headers: {
				'Authorization': `Bearer ${await dotNetRef.invokeMethodAsync('GetAccessToken')}`
			}
		});

		if (response.ok) {
			const data = await response.json();
			return data.url;
		} else {
			window.showNotification('Error al subir imagen', 'error');
			return null;
		}
	} catch (error) {
		console.error('Error uploading image:', error);
		window.showNotification('Error al subir imagen', 'error');
		return null;
	}
}

// Inicializar captura de cámara
export function initCameraCapture(inputElement) {
	// En dispositivos móviles, el atributo capture="environment" ya abre la cámara
	// Esta función es por si necesitamos lógica adicional
	if (inputElement) {
		inputElement.setAttribute('capture', 'environment');
		inputElement.setAttribute('accept', 'image/*');
	}
}

// Detectar si está escribiendo (debounce)
let typingTimeout = null;
export function handleTypingIndicator(dotNetRef, conversacionId, isTyping) {
	clearTimeout(typingTimeout);

	if (isTyping) {
		dotNetRef.invokeMethodAsync('SendTypingIndicator', conversacionId);
		
		typingTimeout = setTimeout(() => {
			dotNetRef.invokeMethodAsync('SendStoppedTypingIndicator', conversacionId);
		}, 3000);
	}
}

// Formatear fecha para separadores
export function formatDateSeparator(dateString) {
	const date = new Date(dateString);
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	if (date.toDateString() === today.toDateString()) {
		return 'Hoy';
	} else if (date.toDateString() === yesterday.toDateString()) {
		return 'Ayer';
	} else {
		const options = { weekday: 'long', day: 'numeric', month: 'short' };
		return date.toLocaleDateString('es-ES', options);
	}
}

// Exportar funciones al objeto global
if (typeof window !== 'undefined') {
	window.scrollToBottom = scrollToBottom;
}
